import LoginContainer from '../components/LoginContainer'
import { connect } from 'react-redux'
import { login} from '../reducers/actions'

const mapStateToProps = (state) => ({
    user: state.user
})

const mapDispatchToProps = (dispatch, { socket }) => ({
    onLogin: ({username}) => dispatch(login(socket, username)),
})

const Login = connect(
    mapStateToProps, 
    mapDispatchToProps
)(LoginContainer)

export default Login



// WEBPACK FOOTER //
// ./src/containers/Login.js